import ehsCatalog from '@/http/requests/ehsCatalog/index.js'

export default {
  fetchCatalogList({ commit }, data) {
    return new Promise((resolve, reject) => {
      ehsCatalog.list(data)
        .then(response => {
          if (data.page > 1) {
            commit("UPDATE_CATALOG_LIST", response.data.data)
          } else {
            commit("SET_CATALOG_LIST", response.data.data)
          }
          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
    })
  },deleteCatalog({ commit }, id) {
    return new Promise((resolve, reject) => {
      ehsCatalog.delete(id)  
      .then(response => {
          commit("DELETE_CATALOG", response.data.item)
          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
    })
  },
  addCatalog({ commit }, data) {
    return new Promise((resolve, reject) => {
      ehsCatalog.store(data)
        .then(response => {
          commit("ADD_CATALOG", response.data.item)
          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
    })
  },
  updateCatalog({ commit }, data) {
    return new Promise((resolve, reject) => {
      ehsCatalog.update(data) 
      .then(response => {
          commit("UPDATE_CATALOG", response.data.item)
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
    });
  },
}
